import validate from "/usr/src/app/content/n3-redirections-service-349df43e-7806-4186-bed7-605a4c5c02b3/b2c-build/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/usr/src/app/content/n3-redirections-service-349df43e-7806-4186-bed7-605a4c5c02b3/b2c-build/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}